import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForCategoryComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'type',
      options: [
        'A_SUB_TYPE',
        'A_TYPE',
        'ADSERVER',
        'AUDIO_VIDEO_TYPE',
        'AUDIOFORMAT',
        'CHART',
        'COMPILATIONTYPE',
        'CONFIGURATION',
        'CONTENT_TYPE',
        'CONTRIB_FUNC',
        'COUNTRY',
        'DELIVERYSTATE',
        'DIGI_MEDIA',
        'DIGI_PRODUCT',
        'DOCUMENT_TYPE',
        'DVDCOUNTRYCODE',
        'EDITION',
        'EXT_SERVICE',
        'FORMAT',
        'FSK',
        'GENDER',
        'GENRE',
        'GRAPHIC_TYPE',
        'INSTRUMENT',
        'JOB_FUNCTION',
        'JOB_TYPE',
        'KARUSSELL',
        'LINK',
        'MEDIA_EMBED',
        'MFD_CATEGORY',
        'MFD_NEWS_SUBCATEGORY',
        'MFD_SUBCATEGORY',
        'P_TYPE_COOP',
        'P_TYPE_LIVE',
        'P_TYPE_MEDIA',
        'P_TYPE_ONOFF',
        'P_TYPE_PUBLISH',
        'P_TYPE_TRADE',
        'PAGETITLE',
        'POSITION',
        'PRODUCTCATEGORY',
        'PRODUCTFAMILY',
        'PRODUCTGROUP',
        'PRODUCTSUBCATEGORY',
        'PROVINCE',
        'SHOP_TYPE',
        'SHOP',
        'SOFTWARE_TYPE',
        'SUBGENRE',
        'T_TYPE_CAL',
        'T_TYPE_LIVE',
        'T_TYPE_MEDIA',
        'TARGET_GROUP',
        'TEASER_STANDALONE_TYPE',
        'TICKET_SHOP',
        'TITLE',
        'TOPIC',
        'TOUR',
        'UTM_CONTENT',
        'UTM_MEDIUM',
        'UTM_SOURCE',
        'VIDEOFORMAT',
        'VIDEOSTANDARD',
        'WHERE_HEARED',
        'YOUTUBECHANNEL',
        'YOUTUBEPOLICY',
      ],
      type: 'selectValueLabel',
    },
  ];

  defaultColumns = [
    'id',
    'name',
    'shortName',
    'type',
    'topCategory',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'description',
      sortable: true,
    },
    {
      property: 'shortName',
      sortable: true,
    },
    {
      property: 'type',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'topCategory',
      type: 'relation',
    },
    {
      property: 'connectArtistInfo',
    },
    {
      property: 'assetId',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
